import React, { useContext } from 'react';

export const CustomerModalContext = React.createContext(null);

export default CustomerModalContext;

export function useCustomerModalContext() {
    return useContext(CustomerModalContext);
}
